package org.multiplatform.kotfolio.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.multiplatform.kotfolio.components.contactForm
import org.multiplatform.kotfolio.components.sectionTitle
import org.multiplatform.kotfolio.models.Section
import org.multiplatform.kotfolio.util.Constants.SECTION_WIDTH
import org.multiplatform.kotfolio.util.observerViewPortEntered
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.multiplatform.kotfolio.rememberAppState
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun contactSection() {
    val breakpoint = rememberAppState().breakpoint

    Box(
        modifier = Modifier
            .id(Section.Contact.id)
            .fillMaxWidth()
            .maxWidth(SECTION_WIDTH.px)
            .padding(topBottom = if (breakpoint >= Breakpoint.MD) 150.px else 80.px),
        contentAlignment = Alignment.Center,
    ) {
        contactContent(breakpoint)
    }
}

@Composable
private fun contactContent(breakpoint: Breakpoint) {
    val scope = rememberCoroutineScope()
    var animatedRotation by remember { mutableStateOf(0.deg) }

    observerViewPortEntered(
        sectionId = Section.Contact.id,
        distanceFromTop = 500.0,
        onViewPortEntered = {
            animatedRotation = 10.deg
            scope.launch {
                delay(500.milliseconds)
                animatedRotation = 0.deg
            }
        }
    )

    Column(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 95.percent else 90.percent),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        sectionTitle(
            modifier = Modifier
                .fillMaxWidth()
                .margin(bottom = if (breakpoint >= Breakpoint.MD) 64.px else 40.px)
                .transform {
                    rotate(animatedRotation)
                }
                .transition(Transition.of("transform", duration = 500.ms)),
            section = Section.Contact,
            alignment = Alignment.CenterHorizontally,
        )

        contactForm(breakpoint)
    }
}
